import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { replaceHashValues } from "utils/replaceHashValues";

import Header from "common-components/Header";
import { TitleLockup } from "@vds/type-lockups";
import { isMobile } from "utils/style";
import { Button } from "@vds/buttons";
import Container from "common-components/Container";
import StyledLink from "common-components/StyledLink";

class AuthorizedAgentDownloadSuccess extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props, "pageContent", "sc_pagetitle")) {
      this.props.setA11yContent("download success", this.props.pageContent.sc_pagetitle);
    }
  }

  render() {
    if (!checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    const { section_title, buttons, section_description } = this.props.pageContent;

    return (
      <Container>
        <div style={{ maxWidth: "596px" }}>
          <TitleLockup
            surface='light'
            textAlignment='left'
            viewport={isMobile ? "mobile" : "desktop"}
            data={{
              title: {
                size: 'titleLarge',
                bold: false,
                children: convertStringToElements(section_title)
              },
              subtitle: {
                size: 'bodyLarge',
                children: <Div>
                  {convertStringToElements(
                    replaceHashValues(section_description, {
                      notificationMethod: window.reactGlobals.agentInfo.agentEmailId
                    })
                  )}
                </Div>
              }
            }}
          />
          
          <Button
                style={{ marginTop: "16px", fontFamily: 'Verizon-NHG-eDS, Helvetica, Arial, sans-serif' }}
                background={buttons[0].type}
                onClick={() => this.props.history.push("/privacy/secure/authorized-agent")}
              >
               {buttons[0].text}
          </Button>
          {/* <StyledLink
            background={buttons[0].type}
            style={{ marginTop: "16px" }}
            to="/privacy/secure/authorized-agent"
          >
            {buttons[0].text}
          </StyledLink> */}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { download_success_modal: pageContent } }) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { setA11yContent }
)(AuthorizedAgentDownloadSuccess);

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }

  p strong {
    font-size: 20px;
    line-height: 19px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }
`;
